<script>
  export var settings;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";
  import Upgrade from './Upgrade.svelte'
</script>